import React from 'react';
import { motion } from 'framer-motion';
import { AwardIcon, CheckIcon, XIcon } from 'lucide-react';
import { systemNegatives, totalBonuses, totalVolumes } from '../data/offer';
export function SystemSection() {
  return <section className="bg-white tech-grid-light py-16 sm:py-20" aria-labelledby="system-title" data-id="element-233" data-mp="3bhljv43cc8l2">
      <div className="mx-auto max-w-4xl px-4 text-center" data-id="element-234" data-mp="36j0iv2g9lkvk">
        <span className="inline-flex items-center gap-2 rounded-md bg-navy px-4 py-2 text-xs font-extrabold uppercase tracking-[.15em] text-greenGlow" data-id="element-235" data-mp="31kgy35deqf4s">
          <AwardIcon className="h-4 w-4" aria-hidden="true" data-id="element-236" data-mp="2wsflficbume8" /> The most comprehensive renewable energy teaching system
          in the world
        </span>
        <h2 id="system-title" className="mx-auto mt-5 max-w-3xl text-balance text-3xl font-extrabold text-ink sm:text-4xl" data-id="element-237" data-mp="2ntu8c2pmjzku">
          Renewable Energy Complete Collection
        </h2>
        <p className="mt-3 font-semibold text-muted" data-id="element-238" data-mp="2dv4tkit0yv8t">
          {totalVolumes} volumes · {totalBonuses} strategic bonuses · Everything you need to teach with confidence.
        </p>

        <ul className="mx-auto mt-10 grid max-w-3xl gap-3 text-left sm:grid-cols-3" data-id="element-239" data-mp="13xdclv57aulu">
          {systemNegatives.map(item => <motion.li key={item} initial={{
          opacity: 0,
          y: 12
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.28,
          ease: [0.23, 1, 0.32, 1]
        }} className="flex gap-3 rounded-lg border border-line bg-mist p-4 text-sm font-semibold text-muted" data-id="element-240" data-mp="u1k2sjiv9f7r">
              <XIcon className="mt-0.5 h-4 w-4 shrink-0 text-danger" aria-hidden="true" data-id="element-241" data-mp="1crjn6t3ri64u" />
              {item}
            </motion.li>)}
        </ul>

        <p className="mx-auto mt-8 flex max-w-3xl items-start gap-3 rounded-xl border border-green/40 bg-greenSoft p-6 text-left text-lg font-bold leading-relaxed text-ink" data-id="element-242" data-mp="1hp1nxw7mlf1r">
          <CheckIcon className="mt-1 h-6 w-6 shrink-0 text-green" aria-hidden="true" data-id="element-243" data-mp="6ciowgr9lbv3" />
          It's a complete system so you can enter the classroom with confidence and deliver lessons that truly teach how
          to generate, store, and manage renewable energy.
        </p>
      </div>
    </section>;
}